import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import PageLayout from "../scenes/global/PageLayout";
import { useLocalStorageContext } from "../Context/LocalProvider";
import { validateToken, isAuthenticated } from "../utils/authUtils";

const Protected = ({ cmp: Component, ...rest }) => {
  const { data } = useLocalStorageContext();
  const navigate = useNavigate();

  useEffect(() => {
    // Validate token on mount and when data changes
    if (!isAuthenticated() || !validateToken()) {
      navigate("/login", { replace: true });
    }
  }, [data, navigate]);

  if (!data || !isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <PageLayout>
      <Component {...rest} />
    </PageLayout>
  );
};
export default Protected;
